module.exports = __webpack_public_path__ + "static/media/patrol(7).1cd10285.PNG";